module.exports = __webpack_public_path__ + "img/0Q3A3494_L_Foamcore_MockedUp.0231e66f.jpg";